import { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/userAuthentication';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    
    useEffect(() => {
        const token = localStorage.getItem('authToken');
        
        const validateToken = async () => {
            if (!token) {
                navigate('/'); 
                return;
            } else {
                try {
                    const response = await axios.post('https://vibraint.net/api/users/validateToken', {
                        token: token
                    });
    
                    // Invalid token
                    if (!response.data.validated) {
                        logout();
                        return;
                    }
                } catch (error) {
                    localStorage.removeItem('authToken');
                    navigate('/');
                    console.error("Message: ", error)
                    return;
                }
            }
        };

        validateToken();
        // eslint-disable-next-line
    }, [navigate]);

    return children;
};

export default ProtectedRoute;
